import { Role } from '@/core/components/auth/auth.types'
import { getBlogPostById } from '@/core/components/blog/blogQueryOptions'
import { LoadingList } from '@/core/components/LoadingList'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/dashboard/blog/$blogId/edit/')({
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
    if (
      auth.user?.role !== Role['Internal'] &&
      auth.user?.role !== Role['Reseller']
    ) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
  loader: ({ context: { queryClient, auth }, params: { blogId } }) => {
    return queryClient.ensureQueryData(getBlogPostById(auth.token!, blogId))
  },
  pendingComponent: LoadingList,
})
